import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { trackedArray } from "@ember/reactive/collections";

import { type Image, ImageGrid } from "#src/index.ts";

// Picsum photos we hold with only a src, like an upload flow where the file is
// known before its pixels are. The `/seed/<seed>` endpoint always resolves.
const SOURCES = [
  "https://picsum.photos/seed/measure-1/400/300",
  "https://picsum.photos/seed/measure-2/300/400",
  "https://picsum.photos/seed/measure-3/600/240",
  "https://picsum.photos/seed/measure-4/320/320",
  "https://picsum.photos/seed/measure-5/500/280",
  "https://picsum.photos/seed/measure-6/260/380",
  "https://picsum.photos/seed/measure-7/640/320",
  "https://picsum.photos/seed/measure-8/360/300",
];

export default class UnknownDimensions extends Component {
  // A tracked array so replacing an entry re-renders the grid: the new width
  // and height give the item an aspect ratio, and the modifier reflows when it
  // sees that style change in the DOM.
  images: Image[] = trackedArray<Image>(SOURCES.map((src) => ({ src })));

  measure = (event: Event): void => {
    const img = event.target as HTMLImageElement;
    const src = img.getAttribute("src");

    if (!src) return;

    const index = this.images.findIndex((image) => image.src === src && image.width == null);

    if (index === -1) return;

    this.images[index] = { src, width: img.naturalWidth, height: img.naturalHeight };
  };

  <template>
    <ImageGrid @images={{this.images}} as |image|>
      <img src={{image.src}} alt="" {{on "load" this.measure}} />
    </ImageGrid>
  </template>
}
